<style scoped>
.row-line {
  height: 40px;
}

.td-label {
  width: 100px;
  margin-right: 10px;
}

.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
</style>

<template>
  <div>
    <Button @click="showSubmitFrom" type="primary" icon="md-add">归档</Button>
    <Button @click="updateCurrentVersion" type="success" icon="md-refresh" style="margin-left:20px;">同步</Button>
    <Input v-model="curversion" placeholder="请输入当前版本" style="width: 120px;margin-left:5px;"></Input>
    <br/>
    <Button @click="copyURLAction" type="primary" icon="md-copy" >复制</Button>
    <Input v-model="curversiongeturl" readonly style="width: 500px;margin-top:5px;margin-left:20px;"></Input>
    <Table
      :columns="tdata.col_data"
      :data="tdata.current_data"
      :loading="tdata.loading"
      style="margin-top:10px"
      @on-row-click="rowSelect"
    >
      <template slot-scope="{row}" slot="buildfrom">
        {{row.buildfrom == 1?'持续集成':'手动构建'}}
      </template>
      <template slot-scope="{row}" slot="disttype">
        {{row.disttype == 1?'正式发布':'测试发布'}}
      </template>
      <template slot-scope="{row}" slot="copy">
        <Button size="small" @click.stop="copy(row)">复制</Button>
      </template>
      <template slot-scope="{row}" slot="updateprovision">
        <Tag  v-if="row.diststate == 1" color="warning">签名中</Tag>
        <Button size="small" v-if="row.diststate != 1" @click.stop="updateprovision(row)">重签名</Button>
      </template>
    </Table>
    <Modal
      v-model="ipaModal.modal"
      title="iOS安装包归档(ipa)"
      @on-visible-change="onModalVisible"
      :mask-closable="false"
    >
      <div style="padding:10px">
        <table style="width:100%;">
          <tr class="row-line">
            <td class="td-label">ipa上传</td>
            <td>
              <Upload
                ref="uploadIpa"
                :format="['ipa']"
                style="float:left"
                :action="fileUpload.uploadurl"
                :data="fileUpload.fileUploadParams"
                :headers="fileUpload.headers"
                :show-upload-list="true"
                :on-success="onIpaFileUploadSuccess"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
              </Upload>
              <span
                style="color:green;margin-left:10px;line-height:32px"
                v-if="fileUpload.hasUpload"
              >已上传</span>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">发布类型</td>
            <td>
              <RadioGroup v-model="ipaModal.submitModel.disttype">
                <Radio :label="1">正式版</Radio>
                <Radio :label="0">测试版</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">发布渠道</td>
            <td>
              <iradiogroup dictcode="app_dist_channel" v-model="ipaModal.submitModel.distchannel"></iradiogroup>
            </td>
          </tr>
          <tr class="row-line" v-show="ipaModal.submitModel.distchannel == 'enterprise'">
            <td class="td-label">profile过期时间</td>
            <td>
              <DatePicker
                :disabled="true"
                type="date"
                v-model="ipaModal.submitModel.expiredate"
                style="width:100%"
                :clearable="false"
                :editable="false"
              ></DatePicker>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">应用版本</td>
            <td>
              <Input v-model="ipaModal.submitModel.appversion" :disabled="true" />
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">Xcode版本</td>
            <td>
              <Input v-model="ipaModal.submitModel.xcodeversion" :disabled="true" />
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">消息推送</td>
            <td>
              <RadioGroup v-model="ipaModal.submitModel.hasmsgpush" :disabled="true">
                <Radio :label="1" :disabled="true">是</Radio>
                <Radio :label="0" :disabled="true">否</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line" v-show="ipaModal.submitModel.hasmsgpush == 1">
            <td class="td-label">推送证书上传</td>
            <td>
              <Upload
                ref="uploadPushCer"
                :format="['p12']"
                style="float:left"
                :action="fileUpload.uploadurl"
                :data="fileUpload.fileUploadParams"
                :headers="fileUpload.headers"
                :show-upload-list="true"
                :on-success="onPushCerFileUploadSuccess"
              >
                <Button icon="ios-cloud-upload-outline">选择证书</Button>
              </Upload>
              <span
                style="color:green;margin-left:10px;line-height:32px"
                v-if="fileUpload.hasPushCerUpload"
              >已上传</span>
            </td>
          </tr>
          <tr class="row-line" v-show="ipaModal.submitModel.hasmsgpush == 1">
            <td class="td-label">推送证书过期时间</td>
            <td>
              <DatePicker
                type="date"
                v-model="ipaModal.submitModel.pushcerexpiredate"
                style="width:100%"
                :clearable="false"
                :editable="false"
              ></DatePicker>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">来电显示</td>
            <td>
              <RadioGroup v-model="ipaModal.submitModel.hascid">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">开发者</td>
            <td>
              <Input v-model="ipaModal.submitModel.developername"></Input>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">自测情况</td>
            <td>
              <RadioGroup v-model="ipaModal.submitModel.selftest">
                <Radio :label="1">已自测</Radio>
                <Radio :label="0">未自测</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line" v-show="ipaModal.submitModel.selftest == 1">
            <td class="td-label">自测设备</td>
            <td>
              <Input v-model="ipaModal.submitModel.testdevice" />
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">更新说明</td>
            <td>
              <Input v-model="ipaModal.submitModel.updateinfo" type="textarea" :rows="4"></Input>
            </td>
          </tr>
          <!-- <tr class="row-line">
            <td class="td-label">手动上传原因</td>
            <td>
              <Input v-model="ipaModal.submitModel.uploadreason" type="textarea" :rows="2"></Input>
            </td>
          </tr> -->
        </table>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="addIpaSubmit">提交</Button>
      </div>
    </Modal>

    <Modal
      v-model="ipaUpdateModal.modal"
      title="填写iOS更新信息"
      @on-visible-change="onModalVisible"
      :mask-closable="false"
    >
      <div style="padding:10px">
        <table style="width:100%;">
          <tr class="row-line">
            <td class="td-label">更新版本号</td>
            <td>
              <Input v-model="ipaUpdateModal.version"></Input>
            </td>
          </tr>
        </table>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="updateIpaMobileProvisionSubmit">开始更新</Button>
      </div>
    </Modal>

    <Modal
      v-model="ipaResignModel.isShowReSignInfo"
      title="重签名"
      :mask-closable="false"
      @on-visible-change="onModalVisible"
    >
      <div style="padding:10px">
        <table style="width:100%;">
          <tr class="row-line">
            <td class="td-label">应用名称</td>
            <td>
              {{ipaResignModel.appName}}
            </td>
          </tr>
        </table>
      </div>

      <div style="padding:10px">
        <table style="width:100%;">
          <tr class="row-line">
            <td class="td-label">应用版本号</td>
            <td>
              {{ipaResignModel.appVersion}}
            </td>
          </tr>
        </table>
      </div>

      <div style="padding:10px;width:100%;"  >
          <RadioGroup v-model="resignmainpushselecttype" @on-change="OnRadioPushCertChange"  >
                <Radio label="selectmb">
                    <span>推送证书选择</span>
                </Radio>
                <Radio label="bymyself">
                    <span>手动上传</span>
                </Radio>
          </RadioGroup>
          <div v-if="resignmainpushselecttype == 'bymyself'" >
                <div style="color: #f8b72a;padding:5px;" >推送证书</div>
                <Upload
                  ref="mainmb"
                  :format="['p12']"
                  style="float:left"
                  :action="fileUpload.uploadfileurl"
                  :data="fileUpload.fileUploadParams"
                  :headers="fileUpload.headers"
                  :show-upload-list="true"
                  :before-upload="onMaxPushCertHandler"
                  :on-success="onPushCertUploadSuccess"
                >
                  <Button icon="ios-cloud-upload-outline">请选择推送证书文件</Button>
                </Upload>
                <span
                  style="color:green;margin-left:10px;line-height:32px"
                  v-if="fileUpload.hasUpload"
                >已上传</span>
                <div  style="clear:both;"></div>

                <div style="width:100%;height:80px;"  >
                    <div style="color:#f8b72a;padding:5px;" >推送证书过期时间</div>
                    <div>
                        <Date-picker @on-change="onPushCertDateChange" v-model="pushCertDateChangeValue" type="date" placeholder="选择日期" style="width: 200px"></Date-picker>
                    </div>
                </div>
                <div  style="clear:both;"></div>
          </div>
          <div v-else>
              <Select v-model="resignmainpushselectcert" style="width:100%;margin-top:10px;" @on-change="OnMainPushSelectChange" >
                <Option v-for="(item, index) in pushcertslist" :value="item.filetag" :label="item.bundleIdName"  v-bind:key="index" >
                    <span style="font-size:12px;">{{item.bundleIdName}}</span>
                    <span v-html="dealExpireDate(item.expiredate)" style="float:right;">America</span>
                </Option>
              </Select>
          </div>
      </div>




      
      <div style="padding:10px;width:100%;" v-if="(ipaResignModel.resign.mainmb || '').length > 0" >

          <RadioGroup v-model="resignmainmbselecttype" @on-change="OnRadioMainMbChange">
              <Radio label="selectmb">
                  <span>描述文件选择</span>
              </Radio>
              <Radio label="bymyself">
                  <span>手动上传</span>
              </Radio>
          </RadioGroup>

         <div style="color:blue;padding:5px;" >{{ipaResignModel.resign.mainmb}}</div>
         <div v-if="resignmainmbselecttype == 'bymyself' ">
            <Upload
              ref="mainmb"
              :format="['mobileprovision']"
              style="float:left"
              :action="fileUpload.uploadfileurl"
              :data="fileUpload.fileUploadParams"
              :headers="fileUpload.headers"
              :show-upload-list="true"
              :before-upload="onMaxMainHandler"
              :on-success="onIpaMainMbUploadSuccess"
            >
              <Button icon="ios-cloud-upload-outline">请选择描述文件</Button>
            </Upload>
            <span
              style="color:green;margin-left:10px;line-height:32px"
              v-if="fileUpload.hasUpload"
            >已上传</span>
         </div>
         <div v-else >
            <Select v-model="resignmainmbselectcert" style="width:100%;" @on-change="OnMainMbSelectChange" >
              <Option v-for="(item, index) in mbcertslist" :value="item.filetag" :label="item.bundleIdName"  v-bind:key="index" >
                  <span style="font-size:12px;">{{item.bundleIdName}}</span>
                  <span v-html="dealExpireDate(item.expiredate)" style="float:right;">America</span>
              </Option>
            </Select>
         </div>
      </div>
      <div  style="clear:both;"></div>

      
      <div v-if="ipaResignModel.resign.subs.length > 0"   >
        <div style="padding:10px;width:100%;" v-for="(item, index) in ipaResignModel.resign.subs" v-bind:key="index" >
            <RadioGroup v-model="item.resignmbselecttype" @on-change="OnRadioSubMbChange(index, item)"  >
                <Radio label="selectmb">
                    <span>描述文件选择</span>
                </Radio>
                <Radio label="bymyself">
                    <span>手动上传</span>
                </Radio>
            </RadioGroup>
            <div style="color:blue;padding:5px;" >{{item.name}}</div>
            <div v-if="item.resignmbselecttype == 'bymyself' " >
                <Upload
                  :ref="'file'+index"
                  :format="['mobileprovision']"
                  style="float:left"
                  :action="fileUpload.uploadfileurl"
                  :data="fileUpload.fileUploadParams"
                  :headers="fileUpload.headers"
                  :show-upload-list="true"
                  :before-upload="onMaxSubHandler(index)"
                  :on-success="(function(){ return function(resp){ return onIpaSubmbUploadSuccess(resp, index, item) } })()"
                >
                <Button icon="ios-cloud-upload-outline">请选择描述文件</Button>
                </Upload>
                <span
                  style="color:green;margin-left:10px;line-height:32px"
                  v-if="fileUpload.hasUpload"
                >已上传</span>
            </div>
            <div v-else >
                <Select v-model="item.resignmbselectcert" style="width:100%;" @on-change="OnSubMbSelectChange(index, item)" >
                  <Option v-for="(item, index) in mbcertslist" :value="item.filetag" :label="item.bundleIdName"  v-bind:key="index" >
                      <span style="font-size:12px;">{{item.bundleIdName}}</span>
                      <span v-html="dealExpireDate(item.expiredate)" style="float:right;">America</span>
                  </Option>
                </Select>
            </div>
            <div  style="clear:both;"></div>
        </div>
      </div>

      <div slot="footer">
        <Button type="primary" size="large" @click="updateIpaMobileResignSubmit">START</Button>
      </div>
    </Modal>


  </div>
</template>

<script>
import iradiogroup from "../../components/iradiogroup";
import axios from '@/utils/axiosconfig'


export default {
  components: {
    iradiogroup
  },
  data() {
    return {
      pushCertDateChangeValue:"",
      resignmainpushselecttype:"selectmb",
      resignmainpushselectcert:"",
      resignmainmbselecttype:"selectmb",
      resignmainmbselectcert:"",
      mbcertslist:[],
      pushcertslist:[],

      fileUpload: {
        hasUpload: false,
        hasPushCerUpload: false,
        fileUploadParams: {
          clientguid: this.$route.params.projectguid,
          userguid: localStorage.userguid
        },
        headers: {
          Authorization: localStorage.token
        },
        uploadurl: this.$axios.defaults.baseURL + "/mqms/file/uploadipa",
        uploadfileurl: this.$axios.defaults.baseURL + "/mqms/file/upload"
      },
      ipaModal: {
        modal: false,
        submitModel: {}
      },
      ipaUpdateModal: {
        version: '',
        modal: false,
        submitModel: {}
      },
      ipaResignModel:{
        isShowReSignInfo:false,
        appName:'',
        appVersion:'',
        resign:{
          mainmb:"",
          subs:[]
        }
      },
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          // {
          //   type: "selection",
          //   width: 60,
          //   align: "center"
          // },
          // {
          //   type: "index",
          //   width: 60,
          //   align: "center"
          // },
          {
            title: "应用版本号",
            key: "appversion"
          },
          {
            title: "Xcode版本号",
            key: "xcodeversion"
          },
          {
            title: "发布类型",
            key: "disttype",
            slot: "disttype"
          },
          {
            title: "发布渠道",
            key: "distchannel"
          },
          {
            title: "构建来源",
            key: "buildfrom",
            slot: "buildfrom"
          },
          {
            title: "过期日期",
            key: "expiredate"
          },
          {
            title: "开发者",
            key: "developername"
          },
          {
            title: "创建日期",
            key: "createtime"
          },
          {
            title: "操作",
            slot: "copy"
          },
          {
            title: "重签名",
            slot: "updateprovision"
          }
        ]
      },
      currentDisplayName:"",
      curversion:"",
      curversiongeturl:"",
    };
  },
  props: ["approwid"],
  computed: {
    hasPushCertUpload() {
      if (this.$refs.uploadPushCer != undefined) {
        return this.$refs.uploadPushCer.fileList.length > 0;
      }
      return false;
    }
  },
  methods: {
    getCurrentVersion(){
      let _this = this;
      this.$http.get({
        method: "mqms/app/currentversion",
        params: {
          id: this.approwid
        },
        success: function(data) {
          _this.curversion = data;
        },
        failure(code, msg) {}
      });
    },
    updateCurrentVersion(){
      let _this = this;
      this.$http.post({
        method: "mqms/app/updateversion",
        params: {
          id: this.approwid,
          ver:this.curversion,
        },
        success: function(data) {
          _this.getCurrentVersion();
          _this.$Message.success({
            title: "提示",
            content:"更新成功"
          });
        },
        failure(code, msg) {
          _this.$Message.error({
            title: "失败",
            content: msg
          });
        }
      });
    },
    OnMainPushSelectChange(val){
      let item;
      for (let _itm of this.pushcertslist) {
        if (_itm.filetag == val) {
          item = _itm;
          break;
        }
      }

      if (item) {
        this.ipaResignModel.pushcertfileid = val;
        this.ipaResignModel.pushcertdate = new Date(item.expiredate).getTime().toString();
      }
    },
    OnRadioPushCertChange(){
      this.ipaResignModel.pushcertfileid = "";
      this.ipaResignModel.pushcertdate = "";
      this.pushCertDateChangeValue = "";
    },
    OnRadioSubMbChange(index, row){
      let _this = this;
      row.resignmbselectcert = "";
    },
    OnSubMbSelectChange(index, row){
      // let filetag = row.resignmbselectcert;
      // this.ipaResignModel.submbfileids.push(filetag);
    },
    OnRadioMainMbChange(){
      this.$refs["mainmb"] && this.$refs["mainmb"].clearFiles();
      this.resignmainmbselectcert = "";
      this.ipaResignModel.mainmbfileid = "";
    },
    OnMainMbSelectChange(val){
      this.ipaResignModel.mainmbfileid = val;
    },
    dealExpireDate(expiredate){
        let leavetimestamp = new Date(`${expiredate} 08:00:00`).getTime() - new Date().getTime()
        let leavedays = Math.floor(leavetimestamp/(1000*24*3600));
        if ((leavedays <= 60) && (leavedays > 30)) {
          return  `剩余<span style='color:#fc911d;font-size:12px;' >${leavedays}</span>天`;
        } else if ((leavedays <= 30) && (leavedays > 0)) {
          return  `剩余<span style='color:#e8361b;font-size:12px;' >${leavedays}</span>天`;
        } else if (leavedays <= 0) {
          return  `<span style='color:#e8361b;font-size:12px;' >已过期${leavedays}天</span>`;
        } else {
          return `剩余<span style='color:#347aca;font-size:12px;' >${leavedays}</span>天`;
        }
    },
    showSubmitFrom(){
      this.ipaModal.submitModel.developername = this.currentDisplayName;
      this.ipaModal.modal = true;
    },
    onPushCerFileUploadSuccess(response, file, fileList) {
      if (response.code == 0) {
        this.fileUpload.hasPushCerUpload = true;
        this.ipaModal.submitModel.pushcerfiletag = response.data.id;
        this.$refs.uploadPushCer.clearFiles();
      } else {
        this.$Message.warning({
          title: "提示",
          content: response.msg
        });
      }
    },
    onIpaFileUploadSuccess(response, file, fileList) {
      if (response.code == 0) {
        // this.$Modal.info({
        // content: JSON.stringify(response)
        // });

        this.ipaModal.submitModel.appversion =
          response.data.ipainfo.appinfo.cfbundleShortVersionString;
        this.ipaModal.submitModel.expiredate =
          response.data.ipainfo.provision.expirationDate;
        this.ipaModal.submitModel.xcodeversion =
          response.data.ipainfo.appinfo.dtxcode +
          "(" +
          response.data.ipainfo.appinfo.dtxcodeBuild +
          ")";
        this.ipaModal.submitModel.hasmsgpush =
          response.data.ipainfo.provision.apsEnvironment != null ? 1 : 0;
        this.ipaModal.submitModel.distchannel =
          response.data.ipainfo.provision.provisionsAllDevices != null
            ? "enterprise"
            : "appstore";
        this.ipaModal.submitModel.minimumosversion = response.data.ipainfo.appinfo.minimumOSVersion;
        this.ipaModal.submitModel.teamname = response.data.ipainfo.provision.teamName;
        this.ipaModal.submitModel.teamidentifier = response.data.ipainfo.provision.teamIdentifier;
        this.ipaModal.submitModel.cfbundledisplayname = response.data.ipainfo.appinfo.cfbundleDisplayName;
        this.ipaModal.submitModel.cfbundleidentifier = response.data.ipainfo.appinfo.cfbundleIdentifier;
        this.fileUpload.hasUpload = true;
        this.ipaModal.submitModel.filetag = response.data.id;
        this.$refs.uploadIpa.clearFiles();
      } else {
        this.$Message.warning({
          title: "提示",
          content: response.msg
        });
      }
    },
    addIpaSubmit() {
      let _this = this;
      this.ipaModal.submitModel.approwid = this.approwid;
      this.$http.post({
        method: "mqms/iosdist/add",
        params: this.ipaModal.submitModel,
        success: function(data) {
          _this.ipaModal.modal = false;
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    },
    onModalVisible(visible) {
      if (!visible) {
        this.ipaModal.submitModel = {
          developername:this.currentDisplayName
        };
        this.fileUpload.hasUpload = false;
        this.fileUpload.hasPushCerUpload = false;
        this.$refs.uploadPushCer.clearFiles();
        this.$refs.uploadIpa.clearFiles();
        this.getArchiveList();
        this.ipaResignModel = {
              isShowReSignInfo:false,
              appName:'',
              appVersion:'',
              resign:{
                mainmb:"",
                subs:[]
              }
        };
        this.pushCertDateChangeValue = "";
      }
    },
    getArchiveList() {
      let _this = this;
      this.$http.get({
        method: "mqms/iosdist/list",
        params: {
          approwid: this.approwid
        },
        success: function(data) {
          _this.tdata.current_data = data;
        },
        failure(code, msg) {}
      });
    },
    rowSelect(row) {
      window.open("#/ipadistdetail/" + row.id);
    },
    copy(row) {
      this.ipaModal.modal = true;
      this.ipaModal.submitModel = row;
      this.ipaModal.submitModel.disttype = Number(row.disttype);
      this.ipaModal.submitModel.filetag = null;
      // this.ipaModal.submitModel.expiredate = null;
      // this.ipaModal.submitModel.appversion = null;
      // this.ipaModal.submitModel.xcodeversion = null;
      // this.ipaModal.submitModel.hasmsgpush = null;

      if (row.hasmsgpush && row.pushcerfiletag.length > 0) {
        this.fileUpload.hasPushCerUpload = true;
      }
    },
    updateprovision(row) {
       /// TODO:需要分析下当前 iOS 应用包，重签名需要哪些描述文件
       this.ipaResignModel.appName = row.cfbundledisplayname;
       this.ipaResignModel.appVersion = row.appversion;
       this.ipaResignModel.id = row.id;
       this.ipaResignModel.isShowReSignInfo = true;
  
      let msg = this.$Message.loading({
                    content: '稍等...',
                    duration: 0
                });
      let _this = this;
      this.$http.get({
        method:"mqms/iosdist/analyseappmobileprovision",
        params:{
          id:row.id
        },
        success:function(rlt){
          setTimeout(msg, 0);
          let subArr = [];
          for (let sub of rlt.subs) {
            subArr.push({
              name:sub,
              resignmbselecttype:"selectmb",
              resignmbselectcert:""
            })
          }
          rlt.subs = subArr;
          _this.ipaResignModel.resign = rlt;
          // {
          //   "mainmb":"xxx",
          //   "subs":[]
          // }
        },
        failure:function(){
          setTimeout(msg, 0);
        },
      })

    },
    updateIpaMobileResignSubmit(){
        let id = this.ipaResignModel.id || "";
        if (id.length <= 0) {
          this.$Message.error('缺少重签名参数');
          return ;
        }
        // 获取推送证书文件
        let pushcertfileid = this.ipaResignModel.pushcertfileid || "";
        let pushcertdate = this.ipaResignModel.pushcertdate || "";
        if (pushcertfileid.length > 0) {
          if (pushcertdate.length <= 0) {
            this.$Message.error('推送证书日期必须选择');
            return ;
          }
        }
        let mainmbfileid = this.ipaResignModel.mainmbfileid || "";
        if (mainmbfileid.length <= 0) {
          this.$Message.error('缺少主描述文件');
          return ;
        }
        let submbfileids = this.ipaResignModel.submbfileids || [];
        for (let item of this.ipaResignModel.resign.subs) {
            if ((item.resignmbselectcert || "").length > 0) {
              submbfileids.push(item.resignmbselectcert);
            }
        }
        
        if (this.ipaResignModel.resign.subs.length > 0) {
          if ( (submbfileids.length != this.ipaResignModel.resign.subs.length)) {
            this.$Message.error('缺少插件描述文件');
            return ;
          }
        }

        this.$Spin.show({
          render: (h) => {
              return h('div', [
                  h('Icon', {
                      'class': 'demo-spin-icon-load',
                      props: {
                          type: 'ios-loading',
                          size: 18
                      }
                  }),
                  h('div', '签名中，请稍等')
              ])
          }
        });
        // 开始重签名
        let _this = this;
        this.$http.post({
          method:"mqms/iosdist/resignapp",
          params:{
            id:id,
            mainmbfileid:mainmbfileid,
            submbfileids:submbfileids,
            pushcertfileid:pushcertfileid,
            pushcertdate:pushcertdate
          },
          success:function(rlt){
            _this.$Spin.hide();
            _this.ipaResignModel.isShowReSignInfo = false;
            _this.$Message.succes('签名成功');
          },
          failure:function(){
            _this.$Message.error('签名失败');
          },
        })
    },
    onPushCertUploadSuccess(response, file, fileList){
      if (response.code == 0) {
        this.ipaResignModel.pushcertfileid = response.data.id;
      } else {
        this.$Message.warning({
          title: "提示",
          content: response.msg
        });
      }
    },
    onIpaMainMbUploadSuccess(response, file, fileList){
      if (response.code == 0) {
        this.ipaResignModel.mainmbfileid = response.data.id;
      } else {
        this.$Message.warning({
          title: "提示",
          content: response.msg
        });
      }
    },
    onIpaSubmbUploadSuccess(response, index, row){
      if (response.code == 0) {
        row.resignmbselectcert = response.data.id
        // window.console.log(response.data.id);
        // window.console.log(index);
        window.console.log(row);
        // if (!this.ipaResignModel.submbfileids) this.ipaResignModel.submbfileids = [];
        // this.ipaResignModel.submbfileids.push(response.data.id);
      } else {
        this.$Message.warning({
          title: "提示",
          content: response.msg
        });
      }
    },
    onMaxPushCertHandler(file){
      let pushcertfileid = this.ipaResignModel.pushcertfileid || "";
      if (pushcertfileid.length > 0) {
        this.$Message.error("已上传过推送证书")
        return false;
      }
      return ;
    },
    onMaxMainHandler(file){
      let mainmbfileid = this.ipaResignModel.mainmbfileid || "";
      if (mainmbfileid.length > 0) {
        this.$Message.error("已上传过描述文件")
        return false;
      }
      return ;
    },
    onPushCertDateChange(date = ""){
        if (date.length <= 0) {
          this.ipaResignModel.pushcertdate = "";
        } else {
          this.ipaResignModel.pushcertdate = new Date(date+" 00:00:00").getTime().toString();
        }
    },
    onMaxSubHandler(index){
      let _this =  this;
      return function(){
        let submbfileids = _this.ipaResignModel.submbfileids || [];
        let str = submbfileids[index] || "";
        if (str.length > 0) {
          _this.$Message.error("已上传过描述文件")
          return false;
        }
        return ;
      };
    },
    updateIpaMobileProvisionSubmit() {
      this.$Spin.show({
          render: (h) => {
              return h('div', [
                  h('Icon', {
                      'class': 'demo-spin-icon-load',
                      props: {
                          type: 'ios-loading',
                          size: 18
                      }
                  }),
                  h('div', '正在替换描述文件，请稍后')
              ])
          }
      });

      let _this = this;
      this.ipaUpdateModal.submitModel.approwid = this.approwid;
      window.console.log(this.ipaUpdateModal.submitModel);

      this.$http.get({
        method: "mqms/iosdist/updateMobileProvision",
        params: {
          clientguid: this.$route.params.projectguid,
          approwid: this.ipaUpdateModal.submitModel.approwid,
          id: this.ipaUpdateModal.submitModel.id,
          version: this.ipaUpdateModal.version
        },
        success: function(data) {
          _this.$Spin.hide();
          _this.ipaUpdateModal.modal = false;
          _this.$Message.success('更新描述文件成功');
        },
        failure(code, msg) {
          _this.$Spin.hide();
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    },
    //获取用户信息
    getUserInfo() {
      let _this = this;
      this.$http.get({
        method: "base/user/userinfo",
        params: {},
        success: function (data) {
          _this.currentDisplayName = data.displayname;
          // _this.user.rolename = data[2];
        },
        failure(code, msg) {},
      });
    },

    getCertList(){
        let _this = this;
        this.$http.get({
            method: "base/iosmpbcert/getCertList",
            params: { type:'selectmb'},
            success: function (data) {
                _this.mbcertslist = data;
            },
            failure(code, msg) {
            },
        });
    },

    getPushCertList(){
        let _this = this;
        this.$http.get({
            method: "base/iosmpbcert/getCertList",
            params: { type:'selectpush'},
            success: function (data) {
                _this.pushcertslist = data;
            },
            failure(code, msg) {
            },
        });
    },

    copyURLAction(){
      let copyDom = document.createElement('div')
      copyDom.innerText = this.curversiongeturl
      copyDom.style.position = 'absolute'
      copyDom.style.top='0px'
      copyDom.style.right='-9999px'
      document.body.appendChild(copyDom)
      //创建选中范围
      let range = document.createRange()
      range.selectNode(copyDom)
      //移除剪切板中内容
      window.getSelection().removeAllRanges()
      //添加新的内容到剪切板
      window.getSelection().addRange(range)
      //复制
      let successful = document.execCommand('copy')
      this.$Message.success({
          title: "提示",
          content: "复制成功"
      });
    },
  },
  mounted() {
    this.getArchiveList();
    this.getUserInfo();
    this.getCertList();
    this.getPushCertList();
    this.getCurrentVersion();

    this.curversiongeturl = axios.defaults.baseURL + "/mqms/app/currentversion?id="+this.approwid
  }
};
</script>